import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-estudios',
  templateUrl: './plan-estudios.component.html',
  styleUrls: ['./plan-estudios.component.scss'],
  providers: [DatePipe]
})
export class PlanEstudiosComponent implements OnInit {

  tituloPantalla = "PLAN DE ESTUDIOS";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
